type Benchmark = {
    end: (message: string) => number
}

export function bench(): Benchmark {
    const date = new Date().getTime()

    return {
        end: (message) => {
            const ms = new Date().getTime() - date
            // eslint-disable-next-line no-console
            console.log(`${ms}ms: ${message}`)

            return ms
        },
    }
}
